import { Badge } from '@/shared/components/ui/badge'
import { BILLING_STATUS_LABELS, labelOf } from '@/shared/constants'

type Variant = 'active' | 'inactive' | 'cancelled' | 'info'

// Color por estado (la etiqueta sale de BILLING_STATUS_LABELS).
const STATUS_VARIANT: Record<string, Variant> = {
  PAID: 'active', // verde
  PENDING: 'inactive', // ámbar
  PENDING_PAYMENT: 'inactive',
  OVERDUE: 'cancelled',
  PARTIALLY_PAID: 'info', // azul
  REFUNDED: 'info', // azul
  CANCELLED: 'cancelled', // rojo
}

interface BillingStatusBadgeProps {
  status: string
}

export function BillingStatusBadge({ status }: BillingStatusBadgeProps) {
  const variant = STATUS_VARIANT[status?.toUpperCase() ?? ''] ?? 'inactive'
  return <Badge variant={variant}>{labelOf(BILLING_STATUS_LABELS, status)}</Badge>
}
